import { request } from '../utils';
import { URL } from './constants';

export function menuPermissionsRequest(apiUrl, payload) {
  var parsedPayload = payload.map(function (item) {
    return { permission: item };
  });
  var options = {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json'
    }),
    credentials: 'include',
    body: JSON.stringify(parsedPayload)
  };
  return request(URL(apiUrl), options);
}

export default menuPermissionsRequest;